export const addToHomeScreenPromptStorageKey = 'chartify:a2hs-alarm-prompt-dismissed:v1';

export function isAddToHomeScreenPromptDismissed(): boolean {
  try {
    return window.localStorage.getItem(addToHomeScreenPromptStorageKey) === '1';
  } catch {
    return false;
  }
}

export function dismissAddToHomeScreenPrompt(): void {
  try {
    window.localStorage.setItem(addToHomeScreenPromptStorageKey, '1');
  } catch {
    // Ignore storage failures; the prompt can still be dismissed for this session.
  }
}

export function resetAddToHomeScreenPromptDismissal(): void {
  try {
    window.localStorage.removeItem(addToHomeScreenPromptStorageKey);
  } catch {
    // Ignore storage failures; the Help instructions are still available.
  }
}
